import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SectionWrapperModule } from '../../../../shared/components';
import { PackageSectionComponent } from '../../../../shared/components/organisms/package-section/package-section.component';
import { CmsFacade } from '../../services/cms.facade';
import { BannersComponent } from '../sections/banners/banners.component';
import { FeaturedLinksComponent } from '../sections/featured-links/featured-links.component';
import { FlightOffersComponent } from '../sections/flight-offers/flight-offers.component';
import { SectionBoletinComponent } from '../sections/section-boletin/section-boletin.component';
import { SectionWhyChooseUsComponent } from '../sections/section-why-choose-us/section-why-choose-us.component';

@Component({
  selector: 'app-home-content',
  standalone: true,
  imports: [
    SectionWrapperModule,
    PackageSectionComponent,
    FeaturedLinksComponent,
    BannersComponent,
    FlightOffersComponent,
    SectionWhyChooseUsComponent,
    SectionBoletinComponent,
  ],
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeContentComponent {
  protected readonly cmsFacade = inject(CmsFacade);
}
